import { onValue as subscribe } from "firebase/database";
import { watchNightValue } from "./nightActivity.mjs";
import { observeLeadSubscription } from "./leadsReadDiagnostics.mjs";
const observedSubscribe = (...args) => observeLeadSubscription(subscribe, args);
export const onValue = (...args) => watchNightValue(observedSubscribe, args);
